module.exports = __webpack_public_path__ + "img/6.80ebe7ee.png";